<template>
  <f7-page
    :page-content="false"
  >
    <f7-navbar
      class="bg-madai"
      :sliding="false"
      back-link
    >
      <f7-nav-title class="text-white" title="Diseño Personalizado" subtitle="Churumbela"></f7-nav-title>
    </f7-navbar>

    <f7-toolbar tabbar position="top">
      <f7-link tab-link="#tab-1" :tab-link-active="tabSeleccionado === 0" @click="tabSeleccionado = 0">
        <i class="material-icons">description</i>
      </f7-link>
      <f7-link tab-link="#tab-2" :tab-link-active="tabSeleccionado === 1" @click="tabSeleccionado = 1">
        <img src="assets/img/menu/compromiso.svg" alt="" width="28" class="m-l-0">
      </f7-link>
      <f7-link tab-link="#tab-3" :tab-link-active="tabSeleccionado === 2" @click="tabSeleccionado = 2">
        <img src="assets/img/filtros/gema.svg" alt="" width="28">
      </f7-link>
      <f7-link tab-link="#tab-5" :tab-link-active="tabSeleccionado === 3" @click="tabSeleccionado = 3">
        <i class="material-icons">assignment_turned_in</i>
      </f7-link>
      <f7-link tab-link="#tab-6" :tab-link-active="tabSeleccionado === 4" @click="tabSeleccionado = 4">
        <i class="material-icons">person</i>
      </f7-link>
    </f7-toolbar>
    <f7-tabs>
      <f7-tab id="tab-1" class="page-content" :tab-active="tabSeleccionado === 0">
        <f7-block class="m-b-15 bold">¿Quieres algo para ti? ó ¿Para alguien especial?</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item class="required" title="Selecciona una opción" smart-select>
            <select name="para-quien-es">
              <option value="Para mi" selected>Para mi</option>
              <option value="Alguien más">Alguien más</option>
              <option value="Para mi y alguien más">Para mi y alguien más</option>
            </select>
          </f7-list-item>
        </f7-list>

        <f7-block class="m-b-15 bold">¿Tienes un diseño en mente? o ¿Te gustaría que te propusieramos ideas?</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item class="required" title="Selecciona una opción" smart-select>
            <select name="diseno-en-mente">
              <option value="Ya sé que diseño va a tener" selected>Ya sé que diseño va a tener</option>
              <option value="No estoy seguro (a) de cómo será, pero tengo ideas">No estoy seguro (a) de cómo será, pero tengo ideas</option>
              <option value="Me gustaría recibir ideas">Me gustaría recibir ideas</option>
            </select>
          </f7-list-item>
        </f7-list>

        <f7-block class="m-b-15 bold">Háznos saber si tienes una fecha planeada para asegurarnos de tenerlo a tiempo</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item class="required" title="Selecciona una opción" smart-select>
            <select name="diseno-en-mente">
              <option value="Sí, tengo fecha" selected>Sí, tengo fecha</option>
              <option value="No tengo fecha, pero sí será pronto (menos de 3 meses)">No tengo fecha, pero sí será pronto (menos de 3 meses)</option>
              <option value="No tengo fecha, pero no hay prisa (mas de 3 meses)">No tengo fecha, pero no hay prisa (mas de 3 meses)</option>
              <option value="Solo estoy cotizando por ahora">Solo estoy cotizando por ahora</option>
            </select>
          </f7-list-item>
          <li class="required">
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">Selecciona la fecha de entrega</div>
                <div class="item-input-wrap">
                  <input
                    type="text"
                    readonly="readonly"
                    placeholder="Selecciona la fecha de entrega"
                    ref="fechaPlaneada"
                  />
                </div>
              </div>
            </div>
          </li>
        </f7-list>

        <f7-block class="m-b-15 bold required">¿Cuál es tu rango de precio?</f7-block>
        <f7-block class="m-0 m-b-100">
          <f7-list class="f7-list-item-no-border m-0">
            <f7-list-item>
              <f7-range
                ref="precio"
                :min="5000"
                :max="200000"
                :step="1000"
                :value="[0, 200000]"
                :label="true"
                :dual="true"
              ></f7-range>
            </f7-list-item>
          </f7-list>
        </f7-block>
      </f7-tab>
      <f7-tab id="tab-2" class="page-content" :tab-active="tabSeleccionado === 1">
        <f7-block class="m-b-15 bold">¿De qué material lo deseas?</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item class="required" title="Selecciona una opción" smart-select>
            <select name="seleccion-material">
              <option value="10k" data-option-image="assets/img/cuestionario_img/material_10k_75.png" selected>10 kilates</option>
              <option value="14k" data-option-image="assets/img/cuestionario_img/material_14k_75.png">14 kilates</option>
              <option value="18k" data-option-image="assets/img/cuestionario_img/material_18k_75.png">18 kilates</option>
            </select>
          </f7-list-item>
        </f7-list>

        <f7-block class="m-b-15 bold">¿De qué color lo deseas?</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item class="required" title="Selecciona una opción" smart-select>
            <select name="seleccion-color">
              <option value="Oro Amarillo" data-option-image="assets/img/cuestionario_img/color_oro_amarillo_75.png" selected>Oro Amarillo</option>
              <option value="Oro Blanco" data-option-image="assets/img/cuestionario_img/color_oro_blanco_75.png">Oro Blanco</option>
              <option value="Oro Rosa" data-option-image="assets/img/cuestionario_img/color_oro_rosa_75.png">Oro Rosa</option>
              <option value="Oro Blanco y Rosa" data-option-image="assets/img/cuestionario_img/color_oro_blanco_rosa_75.png">Oro Blanco y Rosa</option>
              <option value="Oro Blanco y Amarillo" data-option-image="assets/img/cuestionario_img/color_oro_blanco_amarillo_75.png">Oro Blanco y Amarillo</option>
              <option value="Florentino" data-option-image="assets/img/cuestionario_img/color_florentino_75.png">Florentino</option>
            </select>
          </f7-list-item>
        </f7-list>

        <f7-block class="m-b-15 bold">¿Qué estilo deseas?</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item class="required" title="Selecciona una opción" smart-select>
            <select name="seleccion-estilo">
              <option value="chanel" data-option-image="assets/img/cuestionario_img/estilo_chanel_75.png" selected>Chanel</option>
              <option value="pave" data-option-image="assets/img/cuestionario_img/estilo_pave_75.png">Pave</option>
              <option value="diente_comp" data-option-image="assets/img/cuestionario_img/estilo_diente_comp_75.png">Diente Compartido</option>
              <option value="surface" data-option-image="assets/img/cuestionario_img/estilo_surface_75.png">Surface Prong</option>
              <option value="barra" data-option-image="assets/img/cuestionario_img/estilo_barra_75.png">Barra</option>
              <option value="bicel" data-option-image="assets/img/cuestionario_img/estilo_bicel_75.png">Bicel</option>
              <option value="otro" data-option-image="assets/img/cuestionario_img/otro_75.png">Otro</option>
            </select>
          </f7-list-item>
          <f7-list-input
            class="required"
            label="Otro"
            type="text"
            placeholder="Escribe el estilo que deseas usar"
          ></f7-list-input>
        </f7-list>

        <f7-block class="m-b-15 bold">Selecciona la cantidad de piedras</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item class="required" title="Selecciona una opción" smart-select>
            <select name="seleccion-cantidad_piedras">
              <option value="eternity" data-option-image="assets/img/cuestionario_img/gema_eternity_75.png" selected>Eternity</option>
              <option value="1/4" data-option-image="assets/img/cuestionario_img/gema_1-4_75.png">1/4</option>
              <option value="1/2" data-option-image="assets/img/cuestionario_img/gema_1-2_75.png">1/2</option>
              <option value="3/4" data-option-image="assets/img/cuestionario_img/gema_3-4_75.png">3/4</option>
            </select>
          </f7-list-item>
        </f7-list>

        <f7-block class="m-b-15 bold">¿Deseas agregar medidas?</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item title="Selecciona una opción" smart-select :smart-select-params="{openIn: 'popover'}">
            <select name="seleccion-medida">
              <option value="medida-no" selected>No</option>
              <option value="medida-si">Si</option>
            </select>
          </f7-list-item>
        </f7-list>

        <f7-row>
          <f7-col>
            <img class="wd-100" src="assets/img/cuestionario_img/medida_diagrama_churmbela.png" alt="">
          </f7-col>
        </f7-row>

        <f7-list class="m-t-0 m-b-80" >
          <f7-list-input
            class="required"
            label="Ancho"
            type="text"
            placeholder="Escribe el ancho en cm"
          ></f7-list-input>
          <f7-list-input
            class="required"
            label="Espesor"
            type="text"
            placeholder="Escribe el espesor en cm"
          ></f7-list-input>
          <f7-list-input
            class="required"
            label="Medida"
            type="text"
            placeholder="Escribe el medida en cm"
          ></f7-list-input>
        </f7-list>
      </f7-tab>
      <f7-tab id="tab-3" class="page-content" :tab-active="tabSeleccionado === 2">
        <f7-block class="m-b-15 bold">Selecciona la forma de las Gemas</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item class="required" title="Selecciona una opción" smart-select>
            <select name="seleccion_gema">
              <option value="diamante" data-option-image="assets/img/cuestionario_img/gema_diamante_75.png" selected>Diamante</option>
              <option value="piedra_preciosa" data-option-image="assets/img/cuestionario_img/gema_piedra_preciosa_75.png">Piedra Preciosa</option>
            </select>
          </f7-list-item>
        </f7-list>

        <f7-block class="m-b-15 bold">Selecciona la forma de las Gemas</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item class="required" title="Selecciona una opción" smart-select>
            <select name="seleccion_corte_gema">
              <option value="redondo" data-option-image="assets/img/cuestionario_img/corte_redondo_75.png" selected>Redondo</option>
              <option value="princesa" data-option-image="assets/img/cuestionario_img/corte_princesa_75.png">Princesa</option>
            </select>
          </f7-list-item>
        </f7-list>

        <f7-block class="m-b-0 m-t-30 bold">¿Qué tamaño de Gema deseas?</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item class="required" title="Selecciona una opción" smart-select>
            <select name="seleccion_tamano_gema_principal">
              <option value="0.5pt" data-option-image="assets/img/cuestionario_img/gema_25pt_75.png" selected>0.5 Pt, 1 mm</option>
              <option value="1pt" data-option-image="assets/img/cuestionario_img/gema_35pt_75.png">1 Pt, 1.3 mm</option>
              <option value="5pt" data-option-image="assets/img/cuestionario_img/gema_45pt_75.png">5 Pt, 2.4 mm</option>
              <option value="10pt" data-option-image="assets/img/cuestionario_img/gema_55pt_75.png">10 Pt, 3 mm</option>
              <option value="15pt" data-option-image="assets/img/cuestionario_img/gema_65pt_75.png">15 Pt, 3.4 mm</option>
              <option value="20pt" data-option-image="assets/img/cuestionario_img/gema_75pt_75.png">20 Pt, 3.8 mm</option>
            </select>
          </f7-list-item>
        </f7-list>

        <f7-block class="m-b-15 bold">Selecciona la claridad de las Gemas</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item class="required" title="Selecciona una opción" smart-select>
            <select name="seleccion_claridad">
              <option value="no_se" data-option-image="assets/img/cuestionario_img/otro_75.png" selected>Todavía no lo sé</option>
              <option value="fl" data-option-image="assets/img/cuestionario_img/claridad_fl_75.png">FL</option>
              <option value="if" data-option-image="assets/img/cuestionario_img/claridad_if_75.png">IF</option>
              <option value="vvs1" data-option-image="assets/img/cuestionario_img/claridad_vvs1_75.png">VVS1</option>
              <option value="vvs2" data-option-image="assets/img/cuestionario_img/claridad_vvs2_75.png">VVS2</option>
              <option value="vs1" data-option-image="assets/img/cuestionario_img/claridad_vs1_75.png">VS1</option>
              <option value="vs2" data-option-image="assets/img/cuestionario_img/claridad_vs2_75.png">VS2</option>
              <option value="si1" data-option-image="assets/img/cuestionario_img/claridad_si1_75.png">SI1</option>
              <option value="si2" data-option-image="assets/img/cuestionario_img/claridad_si2_75.png">SI2</option>
              <option value="si3" data-option-image="assets/img/cuestionario_img/claridad_si3_75.png">SI3</option>
              <option value="i1" data-option-image="assets/img/cuestionario_img/claridad_i1_75.png">I1</option>
              <option value="i2" data-option-image="assets/img/cuestionario_img/claridad_i2_75.png">I2</option>
              <option value="i3" data-option-image="assets/img/cuestionario_img/claridad_i3_75.png">I3</option>
            </select>
          </f7-list-item>
        </f7-list>

        <f7-block class="m-b-15 bold">Selecciona el color de las Gemas</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item class="required" title="Selecciona una opción" smart-select>
            <select name="seleccion_color_gemas">
              <option value="no_se" data-option-image="assets/img/cuestionario_img/otro_75.png" selected>Todavía no lo sé</option>
              <option value="d" data-option-image="assets/img/cuestionario_img/color_d_75.png">D</option>
              <option value="e" data-option-image="assets/img/cuestionario_img/color_e_75.png">E</option>
              <option value="f" data-option-image="assets/img/cuestionario_img/color_f_75.png">F</option>
              <option value="g" data-option-image="assets/img/cuestionario_img/color_g_75.png">G</option>
              <option value="h" data-option-image="assets/img/cuestionario_img/color_h_75.png">H</option>
              <option value="i" data-option-image="assets/img/cuestionario_img/color_i_75.png">I</option>
              <option value="j" data-option-image="assets/img/cuestionario_img/color_j_75.png">J</option>
              <option value="k" data-option-image="assets/img/cuestionario_img/color_k_75.png">K</option>
              <option value="l" data-option-image="assets/img/cuestionario_img/color_l_75.png">L</option>
              <option value="m" data-option-image="assets/img/cuestionario_img/color_m_75.png">M</option>
              <option value="n" data-option-image="assets/img/cuestionario_img/color_n_75.png">N</option>
              <option value="o" data-option-image="assets/img/cuestionario_img/color_o_75.png">O</option>
              <option value="p" data-option-image="assets/img/cuestionario_img/color_p_75.png">P</option>
              <option value="q" data-option-image="assets/img/cuestionario_img/color_q_75.png">Q</option>
              <option value="r" data-option-image="assets/img/cuestionario_img/color_r_75.png">R</option>
              <option value="s-z" data-option-image="assets/img/cuestionario_img/color_s-z_75.png">S-Z</option>
            </select>
          </f7-list-item>
        </f7-list>
      </f7-tab>
      <f7-tab id="tab-4" class="page-content" :tab-active="tabSeleccionado === 3">
        <f7-block class="m-b-15 bold">¿El anillo llevará algún grabado?</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item title="Selecciona una opción" smart-select :smart-select-params="{openIn: 'popover'}">
            <select name="seleccion-medida">
              <option value="medida-no" selected>No</option>
              <option value="medida-si">Si</option>
            </select>
          </f7-list-item>
          <f7-list-input
            class="required"
            label="Escribe lo que se grabará"
            type="text"
            placeholder="Escribelo aquí"
          ></f7-list-input>
        </f7-list>

        <f7-block class="m-b-15 bold">Información Adicional</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-input
            label="Información adicional"
            type="textarea"
            placeholder="Escribela aquí"
          >
          </f7-list-input>
        </f7-list>

        <f7-block class="m-b-15 bold">Adjuntar imagenes</f7-block>
        <!-- <f7-block class="m-b-15 bold">Titulo</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item class="required" title="Selecciona una opción" smart-select>
            <select name="seleccion_color">
              <option value="" data-option-image="assets/img/cuestionario_img/.png" selected></option>
              <option value="" data-option-image="assets/img/cuestionario_img/.png"></option>
              <option value="" data-option-image="assets/img/cuestionario_img/.png"></option>
            </select>
          </f7-list-item>
        </f7-list> -->
      </f7-tab>
      <f7-tab id="tab-5" class="page-content" :tab-active="tabSeleccionado === 4">
        <f7-block class="m-b-15 bold">Información personal</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-input
            class="required"
            label="Nombre Completo"
            type="text"
            placeholder="Nombre"
          ></f7-list-input>
          <f7-list-input
            class="required"
            label="Celular o Whatsapp"
            type="text"
            placeholder="Número"
          ></f7-list-input>
          <f7-list-input
            class="required"
            label="Correo Electrónico"
            type="text"
            placeholder="Correo"
          ></f7-list-input>
        </f7-list>

        <f7-block class="bold text-danger">
          La información personal se mantendrá estrictamente confidencial y no se venderá, reutilizará, alquilará,
          prestará ni divulgará de otro modo. Solo se utilizará como medio de contacto para hacerte llegar la cotización.
        </f7-block>

        <f7-list class="m-b-80" inset>
          <f7-list-item>
            <f7-button class="margin-auto" fill>Enviar</f7-button>
          </f7-list-item>
        </f7-list>
      </f7-tab>
    </f7-tabs>

    <f7-toolbar tabbar position="bottom">
      <f7-link @click="tabSeleccionado > 0 ? tabSeleccionado-- : tabSeleccionado">Anterior</f7-link>
      <f7-link @click="tabSeleccionado < tabs.length-1 ? tabSeleccionado++ : tabSeleccionado">Siguiente</f7-link>
    </f7-toolbar>
  </f7-page>
</template>

<script>
export default {
  data () {
    return {
      tabs: [1, 2, 3, 4, 5],
      tabSeleccionado: 0
    }
  },
  created () {
    this.$f7.utils.nextFrame(() => {
      this.$f7.calendar.create({
        inputEl: this.$refs.fechaPlaneada,
        dateFormat: 'yyyy/mm/dd',
        value: [new Date()]
      })
    })
  }
}
</script>

<style>
.subtitle {
  color: #fff !important;
}

.navbar {
  background-color: #1D2244 !important;
  color: #fff;
}
</style>
